var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarraBronze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 980,
    height: 21,
    viewBox: "0 0 980 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312.655 20H0V0H318.959L312.655 20Z",
    fill: "#F08080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M328.789 20H326.188L332.476 0H335.073L328.789 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M333.988 20H331.386L337.674 0H340.272L333.988 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M339.187 20H336.585L342.874 0H345.471L339.187 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M344.384 20H341.782L348.071 0H350.668L344.384 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M349.583 20H346.981L353.27 0H355.867L349.583 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M354.782 20H352.18L358.468 0H361.066L354.782 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M359.981 20H357.379L363.668 0H366.265L359.981 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M365.179 20H362.577L368.866 0H371.463L365.179 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M370.377 20H367.775L374.064 0H376.661L370.377 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M375.575 20H372.974L379.262 0H381.86L375.575 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M380.775 20H378.173L384.462 0H387.059L380.775 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M385.973 20H383.371L389.66 0H392.257L385.973 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M391.172 20H388.57L394.859 0H397.456L391.172 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M396.37 20H393.769L400.057 0H402.655L396.37 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M401.569 20H398.967L405.255 0H407.853L401.569 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M406.767 20H404.165L410.454 0H413.051L406.767 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M411.966 20H409.364L415.653 0H418.25L411.966 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M417.164 20H414.562L420.851 0H423.448L417.164 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M422.364 20H419.762L426.05 0H428.648L422.364 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M427.561 20H424.959L431.248 0H433.845L427.561 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M432.76 20H430.158L436.447 0H439.044L432.76 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M437.958 20H435.356L441.645 0H444.242L437.958 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M443.157 20H440.556L446.844 0H449.442L443.157 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M448.356 20H445.754L452.043 0H454.64L448.356 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M453.553 20H450.951L457.24 0H459.837L453.553 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M458.751 20H456.149L462.438 0H465.035L458.751 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M463.951 20H461.35L467.638 0H470.236L463.951 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M469.149 20H466.547L472.836 0H475.433L469.149 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M474.349 20H471.747L478.036 0H480.633L474.349 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M479.546 20H476.944L483.233 0H485.83L479.546 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M484.744 20H482.143L488.431 0H491.029L484.744 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M489.943 20H487.341L493.63 0H496.227L489.943 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M495.142 20H492.54L498.829 0H501.426L495.142 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M500.34 20H497.738L504.027 0H506.624L500.34 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M505.539 20H502.938L509.226 0H511.823L505.539 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M510.737 20H508.135L514.423 0H517.021L510.737 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M515.936 20H513.334L519.623 0H522.22L515.936 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M521.134 20H518.532L524.821 0H527.418L521.134 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M526.332 20H523.73L530.019 0H532.616L526.332 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M531.532 20H528.93L535.218 0H537.816L531.532 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M536.729 20H534.127L540.416 0H543.013L536.729 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M541.928 20H539.326L545.615 0H548.212L541.928 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M547.126 20H544.524L550.813 0H553.41L547.126 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M552.325 20H549.724L556.012 0H558.61L552.325 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M557.524 20H554.922L561.211 0H563.808L557.524 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M562.723 20H560.121L566.41 0H569.007L562.723 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M567.92 20H565.318L571.607 0H574.204L567.92 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M573.119 20H570.518L576.806 0H579.404L573.119 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M578.318 20H575.716L582.005 0H584.602L578.318 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M583.517 20H580.915L587.204 0H589.801L583.517 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M588.715 20H586.113L592.402 0H594.999L588.715 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M593.913 20H591.312L597.6 0H600.197L593.913 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M599.112 20H596.51L602.798 0H605.396L599.112 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M604.311 20H601.709L607.998 0H610.595L604.311 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M609.509 20H606.907L613.196 0H615.793L609.509 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M614.708 20H612.106L618.395 0H620.992L614.708 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M619.906 20H617.304L623.592 0H626.19L619.906 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M625.105 20H622.503L628.792 0H631.389L625.105 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M630.303 20H627.701L633.99 0H636.587L630.303 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M635.502 20H632.9L639.189 0H641.786L635.502 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M640.7 20H638.099L644.387 0H646.985L640.7 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M645.9 20H643.298L649.587 0H652.184L645.9 20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M663.393 20H660.791L667.08 0H669.677L663.393 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M668.591 20H665.989L672.278 0H674.875L668.591 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M673.79 20H671.188L677.477 0H680.074L673.79 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M678.988 20H676.386L682.674 0H685.272L678.988 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M684.187 20H681.585L687.874 0H690.471L684.187 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M689.385 20H686.783L693.072 0H695.669L689.385 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M694.584 20H691.982L698.271 0H700.868L694.584 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M699.782 20H697.181L703.469 0H706.067L699.782 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M704.981 20H702.379L708.668 0H711.265L704.981 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M710.179 20H707.577L713.866 0H716.463L710.179 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M715.378 20H712.776L719.065 0H721.662L715.378 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M720.576 20H717.975L724.263 0H726.861L720.576 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M725.776 20H723.174L729.463 0H732.06L725.776 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M730.974 20H728.372L734.661 0H737.258L730.974 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M736.172 20H733.57L739.859 0H742.456L736.172 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M741.37 20H738.769L745.057 0H747.655L741.37 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M746.57 20H743.968L750.256 0H752.854L746.57 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M751.768 20H749.166L755.455 0H758.052L751.768 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M756.967 20H754.365L760.654 0H763.251L756.967 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M762.164 20H759.562L765.851 0H768.448L762.164 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M767.364 20H764.762L771.05 0H773.648L767.364 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M772.562 20H769.96L776.249 0H778.846L772.562 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M777.761 20H775.159L781.448 0H784.045L777.761 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M782.959 20H780.357L786.646 0H789.243L782.959 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M788.157 20H785.555L791.843 0H794.441L788.157 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M793.355 20H790.753L797.042 0H799.639L793.355 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M798.555 20H795.953L802.242 0H804.839L798.555 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M803.752 20H801.15L807.439 0H810.036L803.752 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M808.952 20H806.351L812.639 0H815.237L808.952 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M814.15 20H811.548L817.837 0H820.434L814.15 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M819.348 20H816.746L823.035 0H825.632L819.348 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M824.546 20H821.944L828.233 0H830.83L824.546 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M829.745 20H827.144L833.432 0H836.03L829.745 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M834.944 20H832.342L838.63 0H841.228L834.944 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M840.143 20H837.541L843.83 0H846.427L840.143 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M845.34 20H842.738L849.027 0H851.624L845.34 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M850.539 20H847.938L854.226 0H856.823L850.539 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M855.738 20H853.136L859.424 0H862.022L855.738 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M860.936 20H858.334L864.623 0H867.22L860.936 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M866.135 20H863.533L869.822 0H872.419L866.135 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M871.332 20H868.73L875.019 0H877.616L871.332 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M876.532 20H873.93L880.218 0H882.816L876.532 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M881.73 20H879.128L885.417 0H888.014L881.73 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M886.929 20H884.327L890.616 0H893.213L886.929 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M892.127 20H889.525L895.814 0H898.411L892.127 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M897.326 20H894.725L901.013 0H903.611L897.326 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M902.524 20H899.922L906.211 0H908.808L902.524 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M907.723 20H905.121L911.41 0H914.007L907.723 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M912.921 20H910.319L916.608 0H919.205L912.921 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M918.12 20H915.519L921.807 0H924.405L918.12 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M923.319 20H920.717L927.005 0H929.603L923.319 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M928.517 20H925.915L932.204 0H934.801L928.517 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M933.715 20H931.113L937.402 0H939.999L933.715 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M938.914 20H936.312L942.601 0H945.198L938.914 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M944.113 20H941.511L947.799 0H950.397L944.113 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M949.312 20H946.71L952.999 0H955.596L949.312 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M954.509 20H951.907L958.196 0H960.793L954.509 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M959.708 20H957.106L963.395 0H965.992L959.708 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M964.907 20H962.305L968.593 0H971.191L964.907 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M970.106 20H967.504L973.793 0H976.39L970.106 19.995V20Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M975.301 20.002H972.702L973.862 16.313L978.99 0.00195312H979.746V5.85695L975.303 19.996L975.301 20.002Z",
    fill: "#888888",
    fillOpacity: 0.75
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M977.901 19.997L979.75 14.438V19.997H977.901Z",
    fill: "#888888",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarraBronze);
export default __webpack_public_path__ + "static/media/barra-bronze.ff4a9eaacfccfccaedb1f9501a62b986.svg";
export { ForwardRef as ReactComponent };